import React, { Component } from 'react';
import { Button, Input, Modal, Tooltip, Typography,Select } from 'antd';
import PopupAddCoins from './PopupAddCoins';
import { MdAddCircle } from 'react-icons/md';
import actions from '../../redux/actions/setting_data';
import { connect } from 'react-redux';
import { isEmpty, forEach } from 'lodash';
import CoinSettingComponent from './CoinSettingComponent';
import * as yup from 'yup'
import utils from '../../common/utils'
import DisplayControl from '../DisplayControl';
import consts from '../../consts';

const {Option} = Select;
const { Text } = Typography;

let schema = yup.object().shape({
  address: yup.string().required("Nhập địa chỉ").trim()
    .matches(/^[a-zA-Z0-9]+$/, { message: "Địa chỉ có a-z, A-Z, 0-9 và không có các kí tự đặc biệt", excludeEmptyString: true })
})

class AddCoinBtnComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      ercModalVisible: false,
      error: '',
      address: '',
      nameCoin: {
        TOMO: 'TOMO',
        ETH: 'ETH',
      },
      coinNames: 'ETH',
    };
  }
  

  checkValueInput = () => {
    console.log(this.state.coinNames,'coin-name')
    const { address } = this.state
    console.log(this.state.address,'address')
    schema.validate({ address }, { abortEarly: false })
      .then(value => this.changePopup())
      .catch(error => {
        this.setState({
          error,
        });
      })
  }

  changePopup = () => {
    if(this.state.coinNames === "TOMO"){
      this.props.fetchTomoErc20Info({ contract: this.state.address, }, this.checkCoinAddress)
    } else if(this.state.coinNames === "ETH"){
      this.props.fetchErc20Info({ contract: this.state.address, }, this.checkCoinAddress)
    }
  };

  checkCoinAddress = (err) => {
    if(err){
      this.setState({
        error: {...this.state.error, message: err}
      })
    }
    else{
    this.setState({ercModalVisible: false, isVisible: true, error: {}})
    }
  }

  coinChange = (value) =>{
    this.setState({
      coinNames:value,
    })
    
  }

  closePopup = (isVisible) => {
    this.setState({
      isVisible,
      address: ''
    });
  };

  showErcModal = () => this.setState({ ercModalVisible: true });
  hideErcModal = () => {
    this.setState({ ercModalVisible: false, address: '', error: {} });
  };

  onChange = ({ target: { value: address } }) => {
    this.setState({ address })
  }


  render() {
    return (
      <>
        <DisplayControl permission_link_screen={consts.AUTH.SETTING__COINS} action={consts.CONTROLS.POST} >
          <Button onClick={this.showErcModal} style={{ size: '2px' }}><MdAddCircle
            size="20" />Thêm</Button>
        </DisplayControl>
        

        <br />

        <Modal
          visible={this.state.ercModalVisible}
          title="Mẫu lấy thông tin coin erc20"
          onOk={this.changePopup}
          onCancel={this.hideErcModal}
          footer={[
            <Button key="cancel" onClick={this.hideErcModal}>
              Hủy
            </Button>,
            <Button key="submit" type="primary" onClick={this.checkValueInput}>
              Xác nhận
            </Button>,
          ]}
        >
          
          <Input placeholder="Nhập địa chỉ contract của ERC20" style={{ width: 400 }}
            value={this.state.address || ''}
            onChange={this.onChange} />
          <div className="text-left p-abs no-wrap" style={{ position: 'relative'}}>
            <Text type='danger'>{utils.upperCaseFirst(this.state.error?.message || '')}</Text>
          </div>
          <Select
            className="mr-medium"
            defaultValue={this.state.nameCoin.ETH}
              style={{ width: 100,marginTop: 6}}
              onChange={this.coinChange}
            >
              {
              
              Object.keys(this.state.nameCoin).map((item, index) => {
                        return (
                          
                          <Option key={item} value={item}>{item}</Option>
                        )
                    })
                  }
            </Select>
        </Modal>

        <PopupAddCoins isVisible={this.state.isVisible} closePopup={this.closePopup}  coinNames={this.state.coinNames} contractAddress={this.state.address} hideErcModal={this.hideErcModal}
          rowUpdate={(this.state.coinNames==='TOMO')?this.props.erc20TomoTokenInfo:((this.state.coinNames==='ETH')?this.props.erc20TokenInfo:null)} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  erc20TokenInfo: isEmpty(state.setting.erc20TokenInfo) ? undefined : {
    coin: state.setting.erc20TokenInfo.Symbol,
    symbol: state.setting.erc20TokenInfo.Symbol,
    decimal: state.setting.erc20TokenInfo.Precision,
    name: state.setting.erc20TokenInfo.Name,
    contract_address: state.setting.erc20TokenInfo.Contract,
    type: 'erc20',
  },
  erc20TomoTokenInfo: isEmpty(state.setting.erc20TomoTokenInfo) ? undefined : {
    coin: state.setting.erc20TomoTokenInfo.Symbol,
    symbol: state.setting.erc20TomoTokenInfo.Symbol,
    decimal: state.setting.erc20TomoTokenInfo.Precision,
    name: state.setting.erc20TomoTokenInfo.Name,
    contract_address: state.setting.erc20TomoTokenInfo.Contract,
    type: 'erc20',
  },
});

const mapDispatchToProps = (dispatch) => ({
  fetchErc20Info: (contract, callback) => {
    dispatch(actions.fetchInfoERC20Action(contract, callback));
  },
  fetchTomoErc20Info: (contract,callback) =>{
    dispatch(actions.fetchTomoInfoERC20Action(contract, callback));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCoinBtnComponent);

